import { useAuth0 } from "@auth0/auth0-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { z } from "zod/v4";
import { FullPageSpinner } from "@/components/basics/full-page-spinner";

const searchSchema = z.object({
  returnTo: z.string().startsWith("/").optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: searchSchema,
  component: LoginPage,
});

function LoginPage() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const { returnTo } = Route.useSearch();
  const redirectingRef = useRef(false);

  useEffect(() => {
    if (isLoading || redirectingRef.current) return;

    if (isAuthenticated) {
      navigate({ to: returnTo ?? "/" });
      return;
    }

    redirectingRef.current = true;
    loginWithRedirect({
      appState: { returnTo: returnTo ?? "/" },
    });
  }, [isLoading, isAuthenticated, loginWithRedirect, navigate, returnTo]);

  return <FullPageSpinner />;
}
